import { LoggerService } from 'services/LoggerService';
import { countries } from 'store/configs/Countries';

const logger = LoggerService.getLogger('StringUtils');

export default class Util {
  // Like str.replace, but allows multiple values.
  // Example:
  //   replaceAll("foo bar foo", {foo:'a', bar:'b'}) == "a b a"
  public static replaceMap(str: string, mapObj: Record<string, string>): string {
    if (!str || !mapObj) {
      logger.error('Missing required replace map values');
      return str;
    }

    const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');

    return str.replace(re, (matched): string => {
      return mapObj[matched];
    });
  }

  public static removeSpaces(str: string): string {
    if (!str || !str.split) {
      return '';
    }

    return str.split(' ').join('');
  }

  public static getPrimaryHashRoute(pathname: string): string {
    return Util.getHashByIndex(pathname, 1);
  }

  public static getHashByIndex(pathname: string, index: number): string {
    if (!pathname || pathname.trim() === '') {
      logger.error('Empty pathname');
      return '';
    }

    const pathSplits = pathname.split('/');
    if (pathSplits.length > index) {
      return pathSplits[index];
    } else {
      return '';
    }
  }

  public static stringEllipses(str: string): string {
    if (!str) {
      return '';
    }

    if (str.length > 10) {
      str = str.substr(0, 10) + '...';
    }

    return str;
  }

  public static countryToCode(str: string): string {
    for (const countryCode of countries) {
      if (countryCode.name === str) {
        return countryCode.value;
      }
    }

    return str;
  }

  public static codeToCountry(str: string): string {
    for (const countryCode of countries) {
      if (countryCode.value === str) {
        return countryCode.name;
      }
    }

    return str;
  }
}
